const SVC = "Usual Sunday Service Time Attended";

const REQ = (label, { vg = false, after = [], extra = [] } = {}) => ({
  title: "Requested by",
  label,
  fields: [
    { k: "Name", label: "Requestor's Name", role: "name", req: true },
    ...after,
    ...(vg ? [{ k: "Victory Group Leader" }] : []),
    { k: SVC, type: "service" },
    { k: "Mobile Number", role: "phone", req: true },
    { k: "Email", role: "email", req: true },
    ...extra,
  ],
});

const PERSON = (title, label, svcLabel = "Service Attended") => ({
  title,
  label,
  fields: [{ k: "Name", label: `${title}'s Name` }, { k: "Victory Group Leader" }, { k: svcLabel, type: "service" }, { k: "Mobile Number" }, { k: "Email" }],
});

const EVENT = { title: "Event Details", date: "Preferred Date", time: "Preferred Time", venue: "Venue", address: "Complete Venue Address", minister: "Preferred Officiating Minister" };

export const PASTORAL = {
  wedding: {
    title: "Wedding", img: "/images/pastoral/wedding.jpg?v=2", event: true,
    text: "Celebrate your covenant before God, surrounded by your church family.",
    requirements: ["Marriage License", "PSA Birth Certificate with Official Receipt (OR)", "PSA Certificate of No Marriage (CENOMAR) with Official Receipt (OR)"],
    sections: [REQ("Requestor's Details"), PERSON("Groom", "Groom's Details", SVC), PERSON("Bride", "Bride's Details", SVC)],
    eventLabels: { ...EVENT, title: "Wedding Details" },
  },
  dedication: {
    title: "Child Dedication", img: "/images/pastoral/dedication.jpg?v=2", event: true,
    text: "Dedicate your little one to the Lord with prayer and blessing.",
    requirements: ["Child's Birth Certificate", "Parents' Marriage Certificate"],
    sections: [REQ("Requestor's Information"), PERSON("Father", "Father's Information"), PERSON("Mother", "Mother's Information"),
      { title: "Child", label: "Child's Information", fields: [{ k: "Child's Full Name" }, { k: "Gender", type: "select", options: ["Male", "Female"] }, { k: "Age" }] }],
    eventLabels: EVENT,
  },
  memorial: {
    title: "Memorial Service", img: "/images/pastoral/memorial.jpg?v=2", event: true,
    text: "Let us stand with you and comfort your family in your time of loss.",
    requirements: ["Death Certificate"],
    sections: [REQ("Requestor's Information", { extra: [{ k: "Relationship to Deceased" }] }),
      { title: "Deceased", label: "Deceased's Information", fields: [{ k: "Full Name of the Deceased" }, { k: "Victory Group Leader" }, { k: "Service Attended", type: "service" }, { k: "Date of Birth" }, { k: "Date of Death" }, { k: "Cause of Death" }] }],
    eventLabels: { ...EVENT, date: "Preferred Service Date", time: "Preferred Service Time" },
  },
  property: {
    title: "Property | Business Dedication", img: "/images/pastoral/property.jpg?v=2", event: true,
    text: "Dedicate your new home, property or business to the Lord.",
    requirements: [],
    sections: [REQ("Requestor's Information", { extra: [{ k: "Nature of Property or Business" }] })],
    eventLabels: { ...EVENT, date: "Preferred Service Date", time: "Preferred Service Time" },
  },
  counseling: {
    title: "Spiritual Guidance | Counselling", img: "/images/pastoral/counseling.jpg?v=2", event: false,
    text: "A safe place to talk, pray and find hope with a minister.",
    requirements: [],
    sections: [REQ("Requestor's Information", { extra: [{ k: "Briefly describe your concern", type: "textarea" }] })],
    eventLabels: { ...EVENT, title: "Preferred Minister", minister: "Preferred Minister" },
  },
  prayer_sick: {
    title: "Pray for the Sick | Hospital Visit Request", img: "/images/pastoral/prayer_sick.jpg?v=2", event: true,
    text: "Request a minister to visit and pray for your loved one.",
    requirements: [],
    sections: [REQ("Requestor's Information", { vg: true, after: [{ k: "Relationship to the Patient" }] }),
      { title: "Patient", label: "Patient's Information", fields: [{ k: "Patient's Full Name" }, { k: "Victory Group Leader" }, { k: SVC, type: "service" }, { k: "Briefly describe the patient's current condition", type: "textarea" }] }],
    eventLabels: { ...EVENT, title: "Hospital Visit Date", date: "Preferred Visit Date", time: "Preferred Visit Time", venue: "Hospital Name", address: "Complete Hospital Address" },
  },
};

export const EVENT_SECTION = "Event Details";
export const PROCESS_NOTE = "After you send this form, you'll get a receipt by email. Our Pastoral Admin will then have a brief interview with you, either by phone call or in person, and check the schedule with our pastors. Your date and minister are only final once you receive our confirmation email.";
